/* Better Safe: header, hero slider, product rails, quick add to cart. Works inside the theme editor too. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------- hero slider ---------- */
  function initSlides(scope) {
    each(scope.querySelectorAll('[data-bs-slides]'), function (box) {
      if (box.__bs) return; box.__bs = true;
      var slides = box.querySelectorAll('.bs-slide');
      var dots = box.querySelector('.bs-dots'), counter = box.querySelector('.bs-counter');
      var speed = (parseFloat(box.getAttribute('data-speed')) || 6.5) * 1000;
      var cur = 0, timer = null;
      if (slides.length < 2) return;
      each(slides, function (s, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'שקופית ' + (i + 1));
        if (!i) b.className = 'bs-on';
        b.addEventListener('click', function () { go(i); restart(); });
        dots.appendChild(b);
      });
      function go(i) {
        cur = (i + slides.length) % slides.length;
        each(slides, function (s, k) { s.classList.toggle('bs-on', k === cur); s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
        each(dots.children, function (d, k) { d.classList.toggle('bs-on', k === cur); });
        box.setAttribute('data-tone', slides[cur].getAttribute('data-tone'));
        if (counter) counter.textContent = (cur + 1) + '/' + slides.length;
      }
      function stop() { clearInterval(timer); timer = null; }
      function restart() { stop(); if (reduce || box.__hold) return; timer = setInterval(function () { go(cur + 1); }, speed); }
      box.__go = function (i) { box.__hold = true; stop(); go(i); };
      box.__release = function () { box.__hold = false; restart(); };
      box.querySelector('.bs-prev').addEventListener('click', function () { go(cur - 1); restart(); });
      box.querySelector('.bs-next').addEventListener('click', function () { go(cur + 1); restart(); });
      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', restart);
      var sx = null;
      box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) { go(cur + (dx > 0 ? 1 : -1)); restart(); }
        sx = null;
      });
      go(0); restart();
    });
  }

  /* ---------- product rails: in RTL moving forward scrolls to the left ---------- */
  function initRails(scope) {
    each(scope.querySelectorAll('[data-bs-rail-sec]'), function (sec) {
      if (sec.__bs) return; sec.__bs = true;
      var rail = sec.querySelector('.bs-rail'); if (!rail) return;
      var prev = sec.querySelector('.bs-r-prev'), next = sec.querySelector('.bs-r-next');
      function step() { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; }
      function state() {
        var max = rail.scrollWidth - rail.clientWidth - 2, x = Math.abs(rail.scrollLeft);
        prev.disabled = x < 2; next.disabled = x > max;
      }
      prev.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', state, { passive: true });
      window.addEventListener('resize', state);
      state();
    });
  }

  /* ---------- phone menu ---------- */
  function initDrawer(scope) {
    each(scope.querySelectorAll('[data-bs-drawer]'), function (drawer) {
      if (drawer.__bs) return; drawer.__bs = true;
      var opener = document.querySelector('[data-bs-open]');
      function open(v) {
        drawer.classList.toggle('bs-open', v);
        drawer.setAttribute('aria-hidden', v ? 'false' : 'true');
        document.documentElement.toggleAttribute('scroll-lock', v);
        if (v) { var f = drawer.querySelector('[data-bs-close]'); if (f) f.focus(); }
        else if (opener) opener.focus();
      }
      if (opener) opener.addEventListener('click', function () { open(true); });
      drawer.querySelector('[data-bs-close]').addEventListener('click', function () { open(false); });
      drawer.addEventListener('click', function (e) { if (e.target === drawer) open(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('bs-open')) open(false); });
    });
  }

  /* ---------- header height for the theme's sticky helpers ---------- */
  function headerHeight() {
    var h = document.querySelector('.bs-sticky');
    if (!h) return;
    var px = h.getBoundingClientRect().height + 'px';
    document.body.style.setProperty('--header-height', px);
    document.body.style.setProperty('--header-group-height', px);
  }

  /* ---------- cart ---------- */
  function setCount(n) {
    each(document.querySelectorAll('[data-bs-count]'), function (el) { el.textContent = n; el.hidden = !n; });
    each(document.querySelectorAll('[data-bs-count-text]'), function (el) { el.textContent = n; });
  }
  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.bs-add');
    if (!b || b.disabled || b.__busy) return;
    var id = parseInt(b.getAttribute('data-variant'), 10); if (!id) return;
    var t = b.querySelector('span'), label = t.textContent;
    b.__busy = true; b.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        b.classList.add('bs-ok'); t.textContent = 'נוסף לעגלה'; refreshCount();
        document.dispatchEvent(new CustomEvent('bs:cart-added', { detail: { id: id } }));
      })
      .catch(function () { t.textContent = 'לא נוסף, נסו שוב'; })
      .then(function () {
        setTimeout(function () { b.classList.remove('bs-ok'); t.textContent = label; b.__busy = false; b.removeAttribute('aria-busy'); }, 1600);
      });
  });
  /* ---------- mini cart: drawer from the cart icon, opened after every add ---------- */
  var onCartPage = /\/cart\/?$/.test(location.pathname);
  function mc() { return document.querySelector('[data-bs-mc]'); }
  function mcOpen(v) {
    var d = mc(); if (!d) return;
    d.classList.toggle('bs-open', v);
    d.setAttribute('aria-hidden', v ? 'false' : 'true');
    document.documentElement.toggleAttribute('scroll-lock', v);
    if (v) { var c = d.querySelector('[data-bs-mc-close]'); if (c) c.focus({ preventScroll: true }); }
  }
  function swap(html, sel) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector(sel), dst = document.querySelector(sel);
    if (src && dst) dst.innerHTML = src.innerHTML;
    var n = doc.querySelector('[data-bs-count-value]');
    return n ? parseInt(n.textContent, 10) : null;
  }
  function render(sections) {
    if (!sections) return;
    var n = null;
    if (sections['bs-mini-cart']) n = swap(sections['bs-mini-cart'], '[data-bs-mc-content]');
    if (sections['bs-cart']) swap(sections['bs-cart'], '[data-bs-cart-page]');
    if (n !== null) setCount(n);
  }
  function wanted() { return document.querySelector('[data-bs-cart-page]') ? 'bs-mini-cart,bs-cart' : 'bs-mini-cart'; }
  function refreshCart() {
    return fetch(root + '?sections=' + wanted(), { cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }
  function afterAdd() {
    refreshCart().then(function () { if (!onCartPage) mcOpen(true); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-bs-cart-link]') && mc() && !onCartPage) { e.preventDefault(); refreshCart(); mcOpen(true); return; }
    if (t.closest('[data-bs-mc-close]') || t === mc()) { mcOpen(false); return; }
    var q = t.closest('[data-bs-q]'); if (!q) return;
    var line = q.closest('[data-bs-line]'); if (!line || line.hasAttribute('data-bs-busy')) return;
    line.setAttribute('data-bs-busy', '');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line.getAttribute('data-bs-line'), 10), quantity: Math.max(0, parseInt(q.getAttribute('data-bs-q'), 10)), sections: wanted(), sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j.sections); if (typeof j.item_count === 'number') setCount(j.item_count); })
      .catch(function () { line.removeAttribute('data-bs-busy'); });
  });
  document.addEventListener('keydown', function (e) { var d = mc(); if (e.key === 'Escape' && d && d.classList.contains('bs-open')) mcOpen(false); });
  document.addEventListener('bs:cart-added', afterAdd);
  /* the theme's product form announces its adds with this event; capture catches it even if it does not bubble */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var a = e && e.detail && (e.detail.action || (e.detail.data && e.detail.data.action));
    /* the event can arrive before the cart is saved, so read it again shortly after */
    setTimeout(function () { if (!a || a === 'add') afterAdd(); else refreshCart(); }, 350);
    setTimeout(refreshCount, 1500);
  }, true);
  document.addEventListener('cart:update', refreshCount);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });

  /* ---------- cookie consent: once per visitor, handed to Shopify's privacy API ---------- */
  function cookieApi(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy) { cb(S.customerPrivacy); return; }
    if (S && S.loadFeatures) {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { cb(err ? null : (window.Shopify && window.Shopify.customerPrivacy) || null); });
    } else cb(null);
  }
  function initCookies(scope) {
    var el = scope.querySelector('[data-bs-ck]'); if (!el || el.__bs) return; el.__bs = true;
    var KEY = 'bs-consent';
    function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function show() { el.hidden = false; requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('bs-show'); }); }); }
    function hide() { el.classList.remove('bs-show'); setTimeout(function () { el.hidden = true; }, 320); }
    el.__show = show; el.__hide = hide;
    function decide(yes) {
      remember(yes ? 'yes' : 'no'); hide();
      if (window.Shopify && window.Shopify.designMode) return;
      cookieApi(function (cp) {
        if (cp && cp.setTrackingConsent) cp.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes }, function () {});
      });
    }
    el.querySelector('[data-bs-ck-yes]').addEventListener('click', function () { decide(true); });
    el.querySelector('[data-bs-ck-no]').addEventListener('click', function () { decide(false); });
    if (window.Shopify && window.Shopify.designMode) return;
    if (stored()) return;
    cookieApi(function (cp) {
      /* where Shopify shows its own banner, leave it to Shopify */
      if (cp && cp.shouldShowBanner && cp.shouldShowBanner()) return;
      if (cp && cp.currentVisitorConsent) {
        var c = cp.currentVisitorConsent() || {};
        if (c.analytics === 'yes' || c.analytics === 'no') return;
      }
      setTimeout(show, 900);
    });
  }
  document.addEventListener('shopify:section:select', function (e) { var el = e.target.querySelector('[data-bs-ck]'); if (el && el.__show) el.__show(); });
  document.addEventListener('shopify:section:deselect', function (e) { var el = e.target.querySelector('[data-bs-ck]'); if (el && el.__hide) el.__hide(); });

  /* ---------- boot ---------- */
  function init(scope) { initSlides(scope); initRails(scope); initDrawer(scope); initCookies(scope); headerHeight(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  window.addEventListener('resize', headerHeight);
  /* Shopify's preview bar covers the bottom of the screen in theme previews; lift the theme's sticky add to cart bar above it */
  function previewBar() { document.documentElement.classList.toggle('bs-pbar', !!document.getElementById('PBarNextFrame')); }
  [0, 1500, 4000].forEach(function (t) { setTimeout(previewBar, t); });

  /* theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var box = e.target.closest('[data-bs-slides]'); if (!box || !box.__go) return;
    var i = Array.prototype.indexOf.call(box.querySelectorAll('.bs-slide'), e.target);
    if (i > -1) box.__go(i);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var box = e.target.closest('[data-bs-slides]'); if (box && box.__release) box.__release();
  });
})();
